<div class="welcome" fxLayout="column" fxLayout.gt-md="row" fxLayoutGap.gt-md="20px" fxLayoutAlign="center centre">
  <section>
    <h1> AdFeeder  Application</h1>
    <p>
      AdFeeder Home Page screen
    </p>
  </section>
  <section>
    <h1> Translations</h1>
    <p>
      AdFeeder Translations App
    </p>
  </section>
</div>
